
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MeteorShowerEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             const count = Math.floor(15 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < count; i++) {
                 const x = ((curTime * 800 + this.pseudoRandom(i) * 5000) % (width * 4)) - width * 2;
                 const y = ((curTime * 800 + this.pseudoRandom(i + 1) * 5000) % (height * 4)) - height * 2;
                 
                 ctx.save();
                 ctx.globalAlpha *= 0.6 / (layerIndex + 1);
                 ctx.lineWidth = 1 * scale;
                 ctx.beginPath();
                 ctx.moveTo(x, y);
                 ctx.lineTo(x - 100 * scale, y - 100 * scale);
                 ctx.stroke();
                 ctx.restore();
             }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
